/**
 * Hình thức thanh toán biên lai
 */
export default {
  Cash: 1, // Tiền mặt
  BankTransfer: 2, // Chuyển khoản
  TransferIncome: 3, // Thu kết chuyển
};

